import "chart.js/auto";
import {Line} from "react-chartjs-2";
import {useAppSelector} from "hooks";
import {CreditCard} from "react-feather";
import {Column, Header} from "components";
import {useTheme} from "styled-components";

interface LoanApplicationsProps {}

export const LoanApplications: React.FC<LoanApplicationsProps> = () => {
  const {black, primary} = useTheme();
  const {charts} = useAppSelector("home");
  const {formulariosChart} = charts;

  return (
    <Column>
      <Header icon={CreditCard} children="Prestamos solicitados" />
      <Line
        style={{maxHeight: 350}}
        data={{
          labels: formulariosChart.map(({fecha}) => fecha),
          datasets: [
            {
              borderWidth: 1,
              borderColor: primary,
              backgroundColor: black,
              label: "Solicitudes",
              data: formulariosChart.map(({total}) => Number(total)),
            },
          ],
        }}
      />
    </Column>
  );
};
